import { NavigationItem } from '@config';
import { isTouchDevice } from '@modules';
import { SxStyleProp, useIsDesktop } from '@themed';
import React from 'react';

export const useNestedNavItemsProps = (items?: NavigationItem[]) => {
  const [isOpen, setIsOpenWithoutLog] = React.useState(false);
  const isDesktop = useIsDesktop();

  if (!items || !isDesktop) {
    return {
      isOpen: false,
      setIsOpen: () => null,
      parentProps: { sx: {} },
      childrenGroupProps: { sx: {} },
    };
  }

  const setIsOpen = (val: boolean) => {
    if (!isTouchDevice()) {
      setIsOpenWithoutLog(val);
    }
  };

  const parentProps = {
    onMouseOver: () => setIsOpen(true),
    onMouseOut: () => setIsOpen(false),
    sx: {
      position: 'relative !important',
      overflow: 'hidden',
    } as SxStyleProp,
  };
  const childrenGroupProps = {
    onMouseOver: () => setIsOpen(true),
    onMouseOut: () => setIsOpen(false),
    sx: {
      // TODO: open/collapse animation?
      position: 'absolute !important',
      display: isOpen ? 'block' : 'none',
      minWidth: 'max-content',
    } as SxStyleProp,
  };

  return {
    isOpen,
    setIsOpen,
    parentProps,
    childrenGroupProps,
  };
};
